export enum BreakType {
  UnscheduledUnpaid = 0,
  UnscheduledPaid = 1,
  Scheduled = 2,
}
